import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { Award, TrendingUp, CheckCircle2, Circle } from 'lucide-react';
export function ScholarshipSection() {
  const [checks, setChecks] = useState([false, false, false]);
  const toggleCheck = (index: number) => {
    const newChecks = [...checks];
    newChecks[index] = !newChecks[index];
    setChecks(newChecks);
  };
  const eligibilityScore = checks.filter(Boolean).length;
  return <section className="py-24 relative bg-slate-50" data-id="element-388">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-389">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-390">
          {/* Left Content */}
          <div className="lg:w-1/2" data-id="element-391">
            <div className="inline-flex items-center space-x-2 bg-gold/10 border border-gold/20 rounded-full px-4 py-1.5 mb-6" data-id="element-392">
              <Award className="w-4 h-4 text-gold" data-id="element-393" />
              <span className="text-xs font-bold tracking-wider uppercase text-gold" data-id="element-394">
                Financial Incentives
              </span>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 leading-tight text-navy" data-id="element-395">
              World-Class Education, <br data-id="element-396" />
              <span className="text-slate-400" data-id="element-397">Accessible to All.</span>
            </h2>

            <p className="text-lg text-slate-600 mb-10 leading-relaxed" data-id="element-398">
              EWU offers one of the most generous financial aid programs in the
              country, distributing over 11 Crore BDT annually to ensure merit
              is the only barrier to entry.
            </p>

            <div className="space-y-6" data-id="element-399">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-white border border-slate-200 shadow-md p-6 rounded-2xl border-l-4 border-l-gold" data-id="element-400">
                <h3 className="text-xl font-bold mb-2 flex items-center text-slate-900" data-id="element-401">
                  Merit-Based Entry Scholarships
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed" data-id="element-402">
                  100% Tuition Free Waiver for top scorers in the Undergraduate
                  Admission Test, or those securing straight A/A+ scores in SSC
                  & HSC / O & A-Levels.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-white border border-slate-200 shadow-md p-6 rounded-2xl border-l-4 border-l-teal" data-id="element-403">
                <h3 className="text-xl font-bold mb-2 flex items-center text-slate-900" data-id="element-404">
                  In-Course Financial Aid
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed" data-id="element-405">
                  Continuous performance-based merit awards and tuition waivers
                  calculated after every academic year based on CGPA
                  maintenance.
                </p>
              </motion.div>
            </div>
          </div>

          {/* Right Interactive Tool */}
          <div className="lg:w-1/2 w-full" data-id="element-406">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-white border border-slate-200 rounded-3xl p-8 relative overflow-hidden shadow-xl" data-id="element-407">
              <div className="relative z-10" data-id="element-408">
                <h3 className="text-2xl font-bold mb-2 text-slate-900" data-id="element-409">
                  Check Your Waiver Eligibility
                </h3>
                <p className="text-sm text-slate-500 mb-8" data-id="element-410">
                  Select the criteria that apply to your academic background to
                  see potential scholarship matches.
                </p>

                <div className="space-y-4 mb-8" data-id="element-411">
                  {['Golden GPA 5.00 in both SSC and HSC', 'Top 10% scorer in EWU Admission Test', 'Children of Freedom Fighters quota applicable'].map((item, i) => <div key={i} onClick={() => toggleCheck(i)} className={`flex items-center p-4 rounded-xl border cursor-pointer transition-all ${checks[i] ? 'bg-gold/5 border-gold/40' : 'bg-slate-50 border-slate-200 hover:border-slate-300'}`} data-id="element-412">
                      {checks[i] ? <CheckCircle2 className="w-6 h-6 text-gold mr-4 shrink-0" data-id="element-413" /> : <Circle className="w-6 h-6 text-slate-300 mr-4 shrink-0" data-id="element-414" />}
                      <span className={`text-sm font-medium ${checks[i] ? 'text-slate-900' : 'text-slate-600'}`} data-id="element-415">
                        {item}
                      </span>
                    </div>)}
                </div>

                <div className="bg-navy rounded-xl p-6 border border-slate-200 text-center text-white" data-id="element-416">
                  <div className="text-sm text-white/70 font-medium uppercase tracking-wider mb-2" data-id="element-417">
                    Estimated Eligibility
                  </div>
                  {eligibilityScore === 0 ? <div className="text-xl font-bold text-white/90" data-id="element-418">
                      Select criteria above
                    </div> : eligibilityScore === 1 ? <div className="text-2xl font-bold text-teal" data-id="element-419">
                      Up to 50% Waiver
                    </div> : <div className="text-3xl font-bold text-gold" data-id="element-420">
                      100% Tuition Waiver
                    </div>}
                  <button className="mt-6 w-full bg-white text-navy font-bold py-3 rounded-xl hover:bg-slate-100 transition-colors" data-id="element-421">
                    View Detailed Policy
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}